import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useModal, useNavigation } from '.'

export const useTableNavigation = () => {
  const { t } = useTranslation()
  const { currentPage, setOptions, goToPage, goBack } = useNavigation()
  const { openInfoModal } = useModal()

  const getMultitableOptions = (table: {
    id: string
    password: string | null
  }) => {
    if (
      currentPage.page === 'table' &&
      Array.isArray(currentPage.options.multitable)
    ) {
      const existTable = currentPage.options.multitable.find(
        (multitable) => table.id === multitable.id,
      )

      if (!existTable) {
        return [...currentPage.options.multitable, table]
      }

      return currentPage.options.multitable
    } else {
      return [table]
    }
  }

  const handleJoin = (table: { id: string; password: string | null }) => {
    const newMultiTableValue = getMultitableOptions({
      id: table.id,
      password: table.password,
    })
    if (newMultiTableValue.length > 3) {
      openInfoModal(
        {
          text: t('modal.info.maxTables.text'),
        },
        {
          title: t('modal.info.maxTables.title'),
        },
      )
      return
    }
    goToPage('table', {
      tableId: table.id,
      password: table.password,
      multitable: newMultiTableValue,
    })
  }

  const handleChange = (tableId: string) => {
    if (currentPage.page !== 'table') {
      return
    }
    const table = currentPage.options.multitable.find(
      (table) => table.id === tableId,
    )
    if (table) {
      setOptions({
        tableId: table.id,
        password: table.password,
        multitable: currentPage.options.multitable,
      })
    }
  }

  const handleClose = (tableId: string) => {
    if (currentPage.page !== 'table') {
      return
    }
    const filteredTables = currentPage.options.multitable.filter(
      (table) => table.id !== tableId,
    )
    if (!filteredTables.length) {
      goBack()
      return
    }
    if (currentPage.options.tableId === tableId) {
      const firstRemainTable = filteredTables[0]
      setOptions({
        tableId: firstRemainTable.id,
        password: firstRemainTable.password,
        multitable: filteredTables,
      })
      return
    }
    setOptions({
      multitable: filteredTables,
    })
  }

  // TODO: this is a thing for a legacy compatibility reason when we didn't hava a multitable option
  useEffect(() => {
    if (currentPage.page === 'table' && !currentPage.options.multitable) {
      setOptions({
        multitable: [
          {
            id: currentPage.options.tableId,
            password: currentPage.options.password,
          },
        ],
      })
    }
  }, [])

  return {
    joinTable: handleJoin,
    changeTable: handleChange,
    closeTable: handleClose,
  }
}
